import { Product } from './interfaces';

export const initialProduct: Product = {
    id: 0,
    vendorId: 0,
    details: '',
    display: '',
    active: false,
    created: '',
    financialSyncTime: '',
    managedCost: [],
    productCategoryId: undefined,
    productSubCategoryId: '',
    sku: '',
    tradeTypeId: undefined,
    tradeSubTypeId: undefined,
    allowSub: false,
    forceSub: false,
    whitelist: false,
    whitelistClient: false,
    whitelistContractor: false,
    substitutes: [],
    availableInCountries: [],
    equipmentOnlyBundle: false,
    defaultPayout: false,
    financialSyncStatus: '',
    attributes: [],
    img: '',
    imgPrimary: '',
    bundleProducts: [],
};
